var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8,8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,3c-3.78906,0 -7.23437,1.11328 -9.78125,2.97656c-2.55078,1.85938 -4.21875,4.53125 -4.21875,7.52344c0,3.62891 2.47266,6.69922 6,8.55078v6.94922l6.74609,-5.0625c0.41016,0.03125 0.82422,0.0625 1.25391,0.0625c3.78906,0 7.23438,-1.11328 9.78125,-2.97266c2.55078,-1.86328 4.21875,-4.53516 4.21875,-7.52734c0,-2.99219 -1.66797,-5.66406 -4.21875,-7.52344c-2.54687,-1.86328 -5.99219,-2.97656 -9.78125,-2.97656zM16,5c3.39063,0 6.44531,1.01563 8.60156,2.58984c2.15625,1.57422 3.39844,3.65625 3.39844,5.91016c0,2.25391 -1.24219,4.33594 -3.39844,5.91016c-2.15625,1.57422 -5.21094,2.58984 -8.60156,2.58984c-0.49219,0 -0.98437,-0.02734 -1.47656,-0.07422l-0.38281,-0.03125l-4.14062,3.10547v-4.14062l-0.57812,-0.26562c-3.35156,-1.57422 -5.42187,-4.20703 -5.42187,-7.09375c0,-2.25391 1.24219,-4.33594 3.39844,-5.91016c2.15625,-1.57422 5.21094,-2.58984 8.60156,-2.58984z"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.86,105.745v0c0,-2.37333 0.70333,-4.35333 2.11,-5.94c1.41333,-1.58 3.53,-2.37 6.35,-2.37c2.82,0 4.96,0.79 6.42,2.37c1.46,1.58667 2.19,3.56667 2.19,5.94v0c0,2.27333 -0.73,4.18 -2.19,5.72c-1.46,1.53333 -3.6,2.3 -6.42,2.3c-2.82,0 -4.93667,-0.76667 -6.35,-2.3c-1.40667,-1.54 -2.11,-3.44667 -2.11,-5.72zM121.86,105.745v0c0,-2.37333 0.70667,-4.35333 2.12,-5.94c1.40667,-1.58 3.52,-2.37 6.34,-2.37c2.82,0 4.96,0.79 6.42,2.37c1.46,1.58667 2.19,3.56667 2.19,5.94v0c0,2.27333 -0.73,4.18 -2.19,5.72c-1.46,1.53333 -3.6,2.3 -6.42,2.3c-2.82,0 -4.93333,-0.76667 -6.34,-2.3c-1.41333,-1.54 -2.12,-3.44667 -2.12,-5.72zM161.87,105.745v0c0,-2.37333 0.70333,-4.35333 2.11,-5.94c1.41333,-1.58 3.53,-2.37 6.35,-2.37c2.82,0 4.96,0.79 6.42,2.37c1.46,1.58667 2.19,3.56667 2.19,5.94v0c0,2.27333 -0.73,4.18 -2.19,5.72c-1.46,1.53333 -3.6,2.3 -6.42,2.3c-2.82,0 -4.93667,-0.76667 -6.35,-2.3c-1.40667,-1.54 -2.11,-3.44667 -2.11,-5.72z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.895c649e20c8dae11d4d682deead0631.svg";
export { ForwardRef as ReactComponent };